import React from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SEOLink } from './SEOLink';
import { siblingFor } from '../../data/a2SiblingLinks';

/**
 * SiblingIntentLink — A2 Phase 1 reciprocal link between two pages that own
 * different sub-intents of the same topic. Deliberately quieter than
 * PrimaryIntentNotice: it is a cross-reference, not a consolidation signal.
 */
export const SiblingIntentLink = () => {
  const { pathname } = useLocation();
  const sibling = siblingFor(pathname);
  if (!sibling) return null;

  return (
    <section className="pb-10 bg-slate-50" data-testid="sibling-intent-link">
      <div className="max-w-4xl mx-auto px-4">
        <div className="rounded-xl border border-dashed border-slate-300 bg-white px-5 py-4 sm:flex sm:items-center sm:justify-between sm:gap-6">
          <p className="text-slate-600 text-sm leading-relaxed mb-3 sm:mb-0">{sibling.note}</p>
          <SEOLink
            to={sibling.to}
            className="inline-flex items-center gap-2 shrink-0 text-sm font-semibold text-red-700 underline decoration-red-300 transition-colors hover:text-red-900"
            data-testid="sibling-intent-anchor"
          >
            {sibling.anchor}
            <ArrowRight className="h-4 w-4" />
          </SEOLink>
        </div>
      </div>
    </section>
  );
};

export default SiblingIntentLink;
